module.exports = __webpack_public_path__ + "media/images/nabor-8e55911c5ba4f50d40e78648f52f0034.jpg";